import React, { useState } from "react";
import recipeForm from "../assets/timactive/ta_pdpdisplay_recipe/pdpdisplay_recipe_form.png";
import recipeHome from "../assets/timactive/ta_pdpdisplay_recipe/pdpdisplay_recipe_home.png";
import aoForm from "../assets/timactive/ta_swokewam/swokewam_ao_form.png";
import aoList from "../assets/timactive/ta_swokewam/swokewam_ao_list.png";
import fbApi from "../assets/timactive/ta_swokewam/swokewam_fb_api.png";
import gcenterHome from "../assets/timactive/ta_pdp_gcenter/pdp_gcenter_home.png";
import gcenterConfig from "../assets/timactive/ta_pdp_gcenter/pdp_gcenter_config.png";
import deskPhoto from "../assets/timactive/photos/ta_desktop.jpeg";
import { Link } from "react-scroll";

import {
  CodeBracketIcon,
  GlobeAltIcon,
  Cog6ToothIcon,
  ServerIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/solid";

const Apprenticeship = () => {
  const [modalImage, setModalImage] = useState(null);
  const ImageModal = ({ src, alt, onClose }) => (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-30"
    >
      <div
        onClick={(e) => e.stopPropagation()} // <-- empêche la propagation
        className="relative"
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-white text-2xl font-bold"
        >
          ×
        </button>
        <img
          src={src}
          alt={alt}
          className="max-w-screen-lg max-h-screen rounded-md"
        />
      </div>
    </div>
  );
  return (
    <div
      name="alternance"
      className="w-full bg-gradient-to-b from-gray-800 to-black text-white py-20"
    >
      <div className="max-w-screen-lg mx-auto px-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h2 className="text-4xl font-bold inline border-b-4 border-gray-500">
            Mon année 2024-2025 en alternance
          </h2>
          <p className="mt-4 text-lg text-gray-300">
            Retour sur mon expérience professionnelle chez TimActive, en tant
            que développeur full stack en alternance dans le cadre de ma Licence
            3 MIAGE à Nantes Université.
          </p>
        </div>

        <div className="space-y-12">
          {/* L'entreprise */}
          <section>
            <h3 className="text-2xl font-semibold mb-2 text-purple-400">
              L'entreprise
            </h3>
            <p className="text-gray-300">
              TimActive est une entreprise spécialisée dans la création de
              solutions e-commerce sur-mesure, en particulier via la plateforme
              PrestaShop. J’y ai évolué au sein d’une petite équipe dynamique,
              dans un environnement technique exigeant, où l’autonomie, la
              rigueur et la polyvalence étaient indispensables.
            </p>
            <p className="text-gray-300 mt-2">
              En tant qu’alternant, j’ai été pleinement intégré au processus de
              développement, contribuant aux projets clients comme un véritable
              développeur full stack.
            </p>
          </section>

          {/* Missions */}
          <section>
            <h3 className="text-2xl font-semibold mb-2 text-purple-400">
              Mes missions
            </h3>
            <p className="text-gray-300 mb-4">
              J’ai contribué à la conception, au développement et à la
              maintenance de modules PrestaShop personnalisés, sur des projets
              e-commerce à forte valeur ajoutée. Mon travail couvrait l’ensemble
              du cycle de vie des fonctionnalités, de l’analyse des besoins à
              l’implémentation, jusqu’à l’amélioration continue.
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>
                Développement PHP orienté objet et intégration dans
                l’architecture modulaire de PrestaShop
              </li>
              <li>
                Création de fonctionnalités back-office avec Symfony et
                front-end avec Vue.js / Vuex
              </li>
              <li>
                Connexion avec des APIs tierces (Meta, Google, etc.) et
                automatisation via Webhooks & CRON
              </li>
              <li>
                Participation à la gestion de projet en méthode agile et
                communication régulière avec les clients
              </li>
              <li>
                Mise en place de bonnes pratiques DevOps : Docker, GitLab CI/CD,
                environnement de dev complet
              </li>
            </ul>
            <div className="mt-4">
              <div
                className="w-full  bg-gray-700 flex items-center justify-center rounded-md shadow-md"
                style={{ height: "30rem" }}
              >
                <img
                  src={deskPhoto}
                  onClick={() => setModalImage(deskPhoto)}
                  alt="Capture formulaire automation order"
                  className="w-full h-full object-cover rounded-md shadow-md transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                />
              </div>
            </div>
            <div className="mt-6 p-4 bg-gray-700 bg-opacity-50 border-l-4 border-purple-500 rounded-md">
              <div className="flex items-start">
                <svg
                  className="w-6 h-6 text-purple-400 mr-3 mt-1"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M7.17 6.17C5.95 7.39 5 9.12 5 11v2a2 2 0 002 2h2v-2H7v-2c0-1.3.52-2.4 1.17-3.07A4 4 0 0010 6H8a4 4 0 00-.83.17zM17.17 6.17C15.95 7.39 15 9.12 15 11v2a2 2 0 002 2h2v-2h-2v-2c0-1.3.52-2.4 1.17-3.07A4 4 0 0020 6h-2a4 4 0 00-.83.17z" />
                </svg>
                <div>
                  <p className="text-gray-300 italic text-base">
                    « Yanis est un développeur fullstack autonome, capable de
                    gérer ses missions avec efficacité. Au-delà de ses
                    compétences techniques, il se distingue par sa capacité à
                    expliquer clairement les problèmes, à structurer ses
                    présentations et à s'exprimer avec aisance. Une vraie force
                    sur les aspects communication et transmission. »
                  </p>
                  <p className="text-sm text-gray-400 mt-2">
                    — Romain De Véra, CEO de TimActive, tuteur alternance
                    2024-2025
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Stack */}

          <section>
            <h3 className="text-2xl font-semibold mb-2 text-purple-400">
              Stack technique
            </h3>
            <ul className="text-gray-300 space-y-4">
              <li className="flex items-center">
                <CodeBracketIcon className="h-5 w-5 text-purple-400 mr-2" />
                <b>Back-end :</b>&nbsp; PHP 8.2, Symfony
              </li>
              <li className="flex items-center">
                <GlobeAltIcon className="h-5 w-5 text-purple-400 mr-2" />
                <b>Front-end :</b>&nbsp; Vue.js, Vuex
              </li>
              <li className="flex items-center">
                <ServerIcon className="h-5 w-5 text-purple-400 mr-2" />
                <b>Bases de données :</b>&nbsp; MySQL, PostgreSQL
              </li>
              <li className="flex items-center">
                <WrenchScrewdriverIcon className="h-5 w-5 text-purple-400 mr-2" />
                <b>Outils :</b>&nbsp; Docker, GitLab CI/CD, Xdebug, Postman
              </li>
              <li className="flex items-center">
                <Cog6ToothIcon className="h-5 w-5 text-purple-400 mr-2" />
                <b>Environnement :</b>&nbsp; Docker Compose, scripts
                d’installation automatisés
              </li>
            </ul>
            {/* <div className="mt-4">
              <div className="w-full h-64 bg-gray-700 flex items-center justify-center rounded-md shadow-md">
                <p className="text-gray-400">
                  [Placeholder architecture ou terminal Docker]
                </p>
              </div>
            </div> */}
          </section>

          {/* Projets */}
          <section>
            <h3 className="text-2xl font-semibold mb-2 text-purple-400">
              Projets marquants
            </h3>
            <p className="text-gray-300 mb-6">
              Chez TimActive, j’ai développé plusieurs{" "}
              <span className="font-semibold text-white">
                modules PrestaShop
              </span>
              , qui sont des extensions permettant d’ajouter de nouvelles
              fonctionnalités à la boutique e-commerce (ex : automatisations,
              fiches recettes, génération de flux produits, etc.).
            </p>
            <ul className="text-gray-300 space-y-4">
              {/* WhatsApp */}
              <div className="mb-8">
                <li>
                  <span className="font-bold text-white">
                    Module d'automatisation WhatsApp :
                  </span>
                  Ce projet m’a permis de développer une interface complète
                  d’automatisation des messages WhatsApp, intégrée directement
                  dans le back-office PrestaShop. En combinant API Meta, et un
                  système avancé de templates dynamiques, j’ai conçu une
                  solution qui permet au marchand d’envoyer automatiquement des
                  messages personnalisés selon les statuts de commande, ainsi
                  que des campagnes marketing ciblées à sa clientèle. J’ai géré
                  l’ensemble de la logique : formulaire d’automatisation en
                  plusieurs étapes, gestion des variables de template (groupées
                  par composant `header`, `body`, `footer`, `button`),
                  déclencheur basé sur un hook
                  `hookActionOrderStatusPostUpdate`, enregistrement en base, et
                  journalisation des envois.
                </li>
                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="bg-gray-700 rounded-md shadow-md overflow-hidden relative">
                    <img
                      src={aoForm}
                      onClick={() => setModalImage(aoForm)}
                      alt="Capture formulaire automation order"
                      className="w-full h-64 object-cover rounded-md shadow-md transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                    />
                  </div>
                  <div className="bg-gray-700 rounded-md shadow-md overflow-hidden relative">
                    <img
                      src={aoList}
                      onClick={() => setModalImage(aoList)}
                      alt="Capture formulaire automation order"
                      className="w-full h-64 object-cover rounded-md shadow-md transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                    />
                  </div>
                  <div className="bg-gray-700 rounded-md shadow-md overflow-hidden relative">
                    <img
                      src={fbApi}
                      onClick={() => setModalImage(fbApi)}
                      alt="Capture configuration API Whatsapp"
                      className="w-full h-64 object-cover rounded-md shadow-md transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                    />
                  </div>
                </div>
              </div>
              {/* Recettes */}
              <li className="mt-8">
                <div className="mb-8">
                  <li>
                    <span className="font-bold text-white">
                      Module recettes :
                    </span>{" "}
                    développement d’un module complet permettant au client de
                    créer et gérer des fiches recettes dynamiques, associées à
                    des produits et à des catégories du catalogue. L’édition se
                    fait via une interface Vue.js fluide, avec upload et
                    suppression d’images, tri, et aperçu direct. Le front-office
                    affiche les recettes par catégorie de manière claire et
                    responsive.
                    <a
                      href="https://www.pointedepenmarch.com/nos-recettes"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-purple-400 underline ml-1"
                    >
                      Voir le rendu en ligne
                    </a>
                  </li>
                  <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="bg-gray-700 rounded-md shadow-md overflow-hidden relative">
                      <img
                        src={recipeForm}
                        onClick={() => setModalImage(recipeForm)}
                        alt="Capture module recette back office"
                        className="w-full h-full object-contain transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                      />
                    </div>
                    <div className="bg-gray-700 rounded-md shadow-md overflow-hidden relative">
                      <img
                        src={recipeHome}
                        onClick={() => setModalImage(recipeHome)}
                        alt="Capture page recette front office"
                        className="w-full h-full object-contain transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                      />
                    </div>
                  </div>
                </div>
              </li>
              {/* Remplacement du bloc dynamique par XML Google Shopping */}
              <div className="mb-8">
                <li className="mt-8">
                  <span className="font-bold text-white">
                    Gestion de flux XML pour Google Shopping :
                  </span>
                  Le client souhaitait référencer automatiquement ses produits
                  sur Google Shopping. J’ai installé et configuré le module
                  "Google Merchant" pour générer un flux XML conforme aux
                  exigences Google (titre, prix, disponibilité, images,
                  description, etc.). Ce flux est mis à jour chaque jour grâce à
                  une tâche CRON planifiée à 4h du matin. J’ai aussi validé la
                  qualité du flux dans Google Merchant Center, et apporté les
                  correctifs nécessaires au besoin. Ce projet m’a permis de
                  comprendre en profondeur la logique de structuration des flux
                  produits, leur intégration avec les plateformes marketing, et
                  l’importance du référencement automatisé.
                </li>
                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="bg-gray-700 rounded-md shadow-md overflow-hidden relative">
                    <img
                      src={gcenterConfig}
                      onClick={() => setModalImage(gcenterConfig)}
                      alt="Capture configuration module Google Merchant"
                      className="w-full h-64 object-cover rounded-md shadow-md transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                    />
                  </div>
                  <div className="bg-gray-700 rounded-md shadow-md overflow-hidden relative">
                    <img
                      src={gcenterHome}
                      onClick={() => setModalImage(gcenterHome)}
                      alt="Capture aperçu du flux XML dans Google Merchant Center"
                      className="w-full h-64 object-cover rounded-md shadow-md transition-transform duration-300 hover:scale-105 hover:brightness-110 cursor-pointer"
                    />
                  </div>
                </div>
              </div>
            </ul>
          </section>

          {/* Apprentissage */}
          <section>
            <h3 className="text-2xl font-semibold mb-2 text-purple-400">
              Ce que j’ai appris
            </h3>
            <p className="text-gray-300">
              Cette alternance m’a permis de monter en compétence sur l’ensemble
              de la stack, de m’adapter rapidement à des contextes variés et de
              participer à des projets à fort enjeu.
            </p>
            <p className="text-gray-300 mt-2">
              Elle m’a conforté dans mon envie de poursuivre en Master MIAGE,
              pour associer technique, organisation et stratégie digitale.
            </p>
            {/* <p className="text-sm italic text-gray-400 mt-4">
              “Yanis a démontré une vraie capacité à s’adapter, à proposer et à
              délivrer.” — Romain De Véra - CEO de TimActive
            </p> */}
          </section>
        </div>
        <section className="pt-12">
          <h3 className="text-2xl font-semibold mb-2 text-purple-400">
            Et maintenant ?
          </h3>
          <p className="text-gray-300">
            Fort de cette année riche en apprentissages, je souhaitais
            poursuivre chez TimActive. Cependant, suite à des contraintes
            financières, mon entreprise ne pourra malheureusement pas renouveler
            mon contrat d'alternance pour la poursuite de mon Master MIAGE comme
            cela était initialement prévu. Je suis donc à la recherche d’une
            nouvelle alternance dans le cadre de mon Master MIAGE pour
            approfondir mes compétences en développement, architecture
            logicielle et gestion de projet. Ouvert à tout types de
            propositions, n'hésitez pas à me contacter !
          </p>
        </section>
        <div className="mt-4 space-x-4">
          <a
            href="/CV_YanisBenlalam.pdf"
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            Voir mon CV
          </a>
          <a
            href="/Lettre_Recommandation_Yanis_BENLALAM.pdf"
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            Voir la lettre de recommandation
          </a>
          <Link to="contact" smooth duration={500}>
            <a
              href="#contact"
              className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded transition"
            >
              Me contacter
            </a>
          </Link>
        </div>
      </div>
      {modalImage && (
        <ImageModal
          src={modalImage}
          alt="Image agrandie"
          onClose={() => setModalImage(null)}
        />
      )}
    </div>
  );
};

export default Apprenticeship;
